var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvincingIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34375 2.34375C9.34375 1.05141 8.29234 0 7 0C5.70766 0 4.65625 1.05141 4.65625 2.34375C4.65625 3.63609 5.70766 4.6875 7 4.6875C8.29234 4.6875 9.34375 3.63609 9.34375 2.34375ZM7 3.51562C6.35383 3.51562 5.82812 2.98992 5.82812 2.34375C5.82812 1.69758 6.35383 1.17188 7 1.17188C7.64617 1.17188 8.17188 1.69758 8.17188 2.34375C8.17188 2.98992 7.64617 3.51562 7 3.51562Z",
    fill: "#2667B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48438 8.2034H2.3125V5.51641L3.31273 4.51617L2.4841 3.68754L1.14062 5.03102V8.2034H0.554688V9.37527H1.80363L2.80969 16.4846H1.72656V18.8284H0.554688V20.0003H13.4453V18.8284H12.2734V16.4846H11.1904L12.1964 9.37527H13.4453V8.2034H12.8594V5.03102L11.5159 3.6875L10.6872 4.51613L11.6875 5.51641V8.2034H10.5156C10.5156 6.26488 8.93852 4.68777 7 4.68777C5.06148 4.68777 3.48438 6.26488 3.48438 8.2034ZM2.89844 18.8284V17.6565H11.1016V18.8284H2.89844ZM11.0128 9.37527L10.0067 16.4846H7.58594V10.5471H6.41406V16.4846H3.99324L2.98719 9.37527H11.0128ZM7 5.85965C8.29234 5.85965 9.34375 6.91106 9.34375 8.2034H4.65625C4.65625 6.91106 5.70766 5.85965 7 5.85965Z",
    fill: "#2667B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvincingIconBlue);
export default __webpack_public_path__ + "static/media/convincing_icon_blue.0b7a5fb82841d64cd5447ee891c717ab.svg";
export { ForwardRef as ReactComponent };